/**
 * Loads development tools and attaches them to the window object
 * Only runs in development, pie, or stage environments
 */
declare global {
  interface Window {
    useLocalSignup: (port?: number) => void
    useLocalJarvisPlans: (port?: number) => void
    useLocalJarvisShipping: (port?: number) => void
    useLocalJarvisBilling: (port?: number) => void
    useLocalJarvisCountrySelector: (port?: number) => void
  }
}

export const loadDevTools = async (stack: number): Promise<void> => {
  // Only load dev tools in development, pie, or stage environments
  if (stack === 3) {
    return
  }

  try {
    const devTools = await import('./devTools')

    Object.entries(devTools).forEach(([key, value]) => {
      if (key !== '__esModule' && typeof value === 'function') {
        ;((window as unknown) as Record<string, unknown>)[key] = value
      }
    })
  } catch (error) {
    console.error('Failed to load dev tools:', error)
  }
}
